var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:{ 'selected' : _vm.isSelected },on:{"click":function($event){return _vm.$emit('redirect')}}},[_c('i',{class:_vm.iconClasses}),_c('span',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }